function setHalfSpacing() {
  const root = document.documentElement;
  const wrapperWidth = document.querySelector('.header.header--has-menu')?.getBoundingClientRect().width || 0;
  if (!wrapperWidth) return;

  const usableWidth = document.documentElement.clientWidth;
  const result = Math.max((usableWidth - wrapperWidth) / 2, 0);

  root.style.setProperty('--half-spacing', result + 'px');
}

setHalfSpacing();

window.addEventListener('resize', setHalfSpacing);

document.addEventListener('shopify:section:load', setHalfSpacing);
document.addEventListener('shopify:section:reorder', setHalfSpacing);
document.addEventListener('shopify:section:unload', setHalfSpacing);

document.addEventListener('DOMContentLoaded', () => {
  const navigation = document.querySelector('.header.header--has-menu');

  if (!navigation) return;

  navigation.addEventListener('mouseenter', function (e) {
      const tabTitle = e.target.closest('.mega-tab-title');
      if (!tabTitle) return;

      const tab = tabTitle.closest('.mega-menu--custom');
      if (!tab) return;

      const tabTitles = tab.querySelectorAll('.mega-tab-title');
      const tabContents = tab.querySelectorAll('.mega-tab-content');
      const contentsWrapper = tab.querySelector('.mega-tab-contents');

      if (!contentsWrapper) return;

      const index = Array.from(tabTitles).indexOf(tabTitle);

      if (index === -1 || !tabContents[index]) return;

      const activeContent = tab.querySelector('.mega-tab-content.active');
      const targetContent = tabContents[index];

      if (activeContent === targetContent) return;

      /**
       * 获取 wrapper 上下 padding
       */
      const getWrapperPadding = () => {
        const style = getComputedStyle(contentsWrapper);

        const paddingTop = parseFloat(style.paddingTop) || 0;
        const paddingBottom = parseFloat(style.paddingBottom) || 0;

        return paddingTop + paddingBottom;
      };

      /**
       * 获取 content 内第一个非 link 的直接子元素高度
       * 再加上 wrapper 的上下 padding
       */
      const getContentHeight = (content) => {
        if (!content) return 0;

        const firstContent = content.querySelector(
          ':scope > :not(link)'
        );

        if (!firstContent) return 0;

        return firstContent.offsetHeight + getWrapperPadding() + 94;
      };

      // 清除上一次 timer
      clearTimeout(contentsWrapper.__heightTimer);

      /**
       * 当前高度
       *
       * 正常情况下取当前 active content 的第一个有效元素高度。
       * 如果当前正在动画，则直接取 wrapper 当前视觉高度，
       * 避免快速切换时发生跳动。
       */
      let startHeight;

      if (contentsWrapper.style.height) {
        startHeight = contentsWrapper.getBoundingClientRect().height;
      } else {
        startHeight = getContentHeight(activeContent);
      }

      // 锁定当前高度
      contentsWrapper.style.height = `${startHeight}px`;

      // 切换 title
      tabTitles.forEach((title, i) => {
        title.classList.toggle('active', i === index);
      });

      // 切换 content
      if (activeContent) {
        activeContent.classList.remove('active');
      }

      targetContent.classList.add('active');

      // 获取目标高度
      const targetHeight = getContentHeight(targetContent);

      /**
       * 高度一致
       * 不会触发 transitionend，所以直接清除 height
       */
      if (Math.abs(startHeight - targetHeight) < 1) {
        contentsWrapper.style.removeProperty('height');
        return;
      }

      // 强制浏览器确认 startHeight
      void contentsWrapper.offsetHeight;

      const cleanup = () => {
        contentsWrapper.style.removeProperty('height');

        contentsWrapper.removeEventListener(
          'transitionend',
          onTransitionEnd
        );

        clearTimeout(contentsWrapper.__heightTimer);

        contentsWrapper.__heightTimer = null;
      };

      const onTransitionEnd = (event) => {
        if (event.target !== contentsWrapper) return;
        if (event.propertyName !== 'height') return;

        cleanup();
      };

      contentsWrapper.addEventListener(
        'transitionend',
        onTransitionEnd
      );

      requestAnimationFrame(() => {
        contentsWrapper.style.height = `${targetHeight}px`;
      });

      // 防止 transitionend 没触发
      contentsWrapper.__heightTimer = setTimeout(() => {
        cleanup();
      }, 500);
    },
    true
  );
});